 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		244: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"d76fb37","1":"4e2452b","2":"fe204cf","3":"d03ab9e","4":"fb9db2c","5":"e64af49","6":"57c54bc","7":"4caff16","8":"97a82c1","9":"ffbfb0e","10":"2706eeb","11":"7d1e3e1","12":"0b4ae05","13":"cd78446","14":"ca8e767","15":"3e4d163","16":"15265a3","17":"029445f","18":"79fd7eb","19":"ec7b440","20":"4897f5e","21":"b1668c8","22":"e945bd8","23":"7dfd292","24":"ccfc09b","25":"2d7e090","26":"2a6cc13","27":"58253b8","28":"de6450e","29":"dfe9e0a","30":"bc078bf","31":"783629f","32":"adba571","33":"95b9d8d","34":"ea8b439","37":"1a7e83c","38":"b1ef49a","39":"2129d55","40":"5b46aac","41":"6953a97","42":"ca4f007","43":"1b1402d","44":"86ca1bc","45":"ad46d71","46":"a72f149","47":"44cba90","48":"f606fc3","49":"9850b7f","50":"d36b181","51":"595a570","52":"3732ec4","53":"2e70740","54":"7deac43","55":"49a25a3","56":"60ae9ff","57":"e99851a","58":"61225f4","59":"d279cbd","60":"1659d75","61":"177c48f","62":"6919d1a","63":"179f293","64":"b7eb5ee","65":"16f3cb9","66":"210be21","67":"7f51b9e","68":"3745759","69":"1b0d0be","70":"0f8d4cc","71":"22134cb","72":"72391eb","73":"098f725","74":"d1bc95a","75":"76bc5c1","76":"1437d84","77":"6dd5ad9","78":"31cbcbc","79":"c501fe1","80":"0e10d75","81":"7da7df7","82":"ac93537","83":"cddc9f3","84":"bcc1b5e","85":"cc5e513","86":"37be5d5","87":"6a7c71d","88":"b2e0aff6-41012ed","89":"7fe7046","90":"148c0d1","91":"178c815","92":"5eead54","93":"84e3733","94":"e9628aa","95":"35a7089","96":"c3c7c6a","97":"9c024ef","98":"deef5ca","99":"3891a63","100":"f7df0dd","101":"b8ef87b","102":"a45a99c","103":"f684db8","104":"2155784","105":"066675b","106":"05c4b52","107":"2bc9c08","108":"385ae87","109":"3498c74","110":"b2e0aff6-e618cd9","111":"4c9d032","112":"655761f","113":"b2e0aff6-9e04f0f","114":"b2e0aff6-36d176b","115":"1b55260","116":"f5e2be4","117":"571e17d","118":"b917f67","119":"b2e0aff6-e99ff07","120":"2d9c105","121":"e5dde3d","122":"45d8f3a","123":"0cb7a96","124":"c358ba9","125":"25c2846","126":"0ef164b","127":"f067aba","128":"cf32fdb","129":"5d95a8d","130":"9527b17","131":"f4c7405","132":"2a3032c","133":"97a6973","134":"4d48a17","135":"a726826","136":"7ab9b3b","137":"54abaa1","138":"cbeb2ef","139":"2598cae","140":"8a127f1","141":"a3efcaf","142":"4e06753","143":"225e5b3","144":"5c706be","145":"077bfe3","146":"efc935c","147":"931a0a0","148":"4166d52","149":"d67fa34","150":"814f276","151":"b2e0aff6-bffb423","152":"de7ecf0","153":"965d3b9","154":"2ace309","155":"724af2e","156":"eeb1eac","157":"9faf428","158":"c759dc1","159":"c4a7ff6","160":"5ceb5f1","161":"14077d7","162":"3dcb51d","163":"0c48ebd","164":"c326fcc","165":"2f4e05c","166":"237ee8c","167":"a6a225b","168":"1feed9e","169":"90c183f","170":"c935a3b","171":"54b905d","172":"5acf7f3","173":"f486be1","174":"981d708","175":"b2e0aff6-9f196f4","176":"465e8f8","177":"0a3ea3c","178":"960b250","179":"b2e0aff6-6c069fe","180":"1abd42f","181":"b1d2d29","182":"f3c39a9","183":"dc840e1","184":"4a81fb1","185":"2c59662","186":"8178ec2","187":"5b814c1","188":"f9a6beb","189":"40dedaf","190":"cabe3d1","191":"342f154","192":"803ea21","193":"1cbd673","194":"9e11574","195":"b2e0aff6-f428494","196":"ad1d940","197":"4981153","198":"c07151e","199":"8f6eb30","200":"4829220","201":"16f33b0","202":"b2e0aff6-66a052a","203":"df2686f","204":"a748501","205":"9a2d138","206":"79efa5d","207":"ca9ee61","208":"6e40769","209":"55fb672","210":"1ee92c5","211":"b4e8016","212":"cf56b1f","213":"e3fe9aa","214":"95f9600","215":"e6f0ad1","216":"e1d45d5","217":"b2e0aff6-f485e44","218":"7a83948","219":"3381193","220":"a3897b0","221":"576e4c4","222":"8acb4d4","223":"99d5a0e","224":"54d1ceb","225":"f1e72c7","226":"c35cf5e","227":"b2e0aff6-21763e9","228":"b057f01","229":"29b7d13","230":"7b0cd54","231":"b33892d","232":"67f2095","233":"69328ba","234":"9536549","235":"c6fc42d","236":"408eb82","237":"34e5a06","238":"1962d80","239":"b2e0aff6-187e10d","240":"b2e0aff6-c77cb86","241":"bb7ae1a","242":"2174f1c","243":"b2e0aff6-0d884c6","246":"f9878de","247":"9b9df52","248":"d403ac9","249":"b6994e2","250":"54513ec","251":"372cddd","252":"106ce39","253":"3ab7e8c","254":"bae5486","255":"50182a2","256":"a5716b3","257":"be51db3","258":"4672294","259":"ccc45b9","260":"d7b6142"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://koumoul.com/data-fair/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
